class Navigation {

  constructor() {
    this.openItem = null;
    this.isOpen = false;
  }

  init(menuSelector) {
    this.menu = document.querySelector(menuSelector);
    this.initListeners()

    return this;
  }

  initListeners() {
    let parents = this.menu.querySelectorAll('.nav > li');
    let toggleClasses = document.querySelectorAll('.toggle-menu');

    if (toggleClasses) {
      toggleClasses.forEach(x => x.addEventListener('click', () => {
        if (this.isOpen) {
          return this.closeMenu();
        }
        this.openMenu()
      }))
    }

    parents
      .forEach(x => x.addEventListener('click', (e) => this.listener(e)))
  }

  initSearch(search) {
    this.search = search;
  }

  listener(e) {
    let obj = e.target.closest('li');

    if (!obj.querySelector('.sub-menu-wrap') && !obj.classList.contains('toggle-menu')) {
      return;
    }

    e.preventDefault();

    this.openMenu()
    this.toggleItem(obj)

    if (window.screen.availWidth > 1023 && !this.openItem) {
      this.closeMenu()
    }
  }

  closeMenu() {
    if (this.isOpen) {
      document.body.classList.remove('menu-open')
    }

    this.toggleItem(null)
    this.isOpen = false;
  }

  toggleItem(item) {
    let prevItem = this.openItem;

    if (this.openItem) {
      this.openItem.classList.remove('open')
      this.openItem = null;
    }

    if (item && prevItem !== item) {
      this.openItem = item;
      this.openItem.classList.add('open')
    }
  }

  openMenu() {
    this.isOpen = true;
    document.body.classList.add('menu-open')
    if (this.search && this.search.isOpen) {
      this.search.close();
    }
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./scripts/libs/Navigation.js